import { HttpErrorResponse } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { FORM_COMP_MODES } from '@services/constants.service';
import { UserService } from '@services/user.service';

@Component({
  selector: 'app-email-form-legacy',
  templateUrl: './email-form-legacy.component.html',
  styleUrls: ['./email-form-legacy.component.scss'],
  standalone: false
})
export class EmailFormLegacyComponent implements OnInit {

  @Input('email') email: string | undefined;
  @Input('mode') mode: string | undefined;
  @Input('username') username: string = "";
  @Output() exitFormEvent = new EventEmitter<boolean>();

  public emailForm: FormGroup;
  public emailError: string = '';
  public emailLoading: boolean = false;
  public defaultFormValues: any = {};

  // necessary to reference it in the html template
  public readonly FORM_COMP_MODES = FORM_COMP_MODES;

  constructor(
    private formBuilder: FormBuilder,
    private userService: UserService,
    private translateService: TranslateService,
  ) {
    this.emailForm = this.formBuilder.group({
      email: ['',
        Validators.compose([Validators.required, Validators.email])
      ],
      editing: [false],
    });
  }

  ngOnInit(): void {
    if (this.mode === FORM_COMP_MODES.DISPLAY) {
      if (this.email) {
        this.emailForm.patchValue({ email: this.email, editing: false });
      }
    } else {
      if (this.email) {
        this.emailForm.patchValue({ email: this.email, editing: true });
      }
    }
  }


  private updateEmail() {
    this.emailLoading = true;
    this.emailError = '';

    this.userService.updateEmail(
      this.emailForm.controls['email'].value,
      this.username
    ).then(() => {
      this.emailError = '';
      this.emailLoading = false;

      this.showForm(this.emailForm);
      this.exitFormEvent.emit(true);
    }).catch((error: any) => {
      this.emailLoading = false;
      this.emailError = error || this.translateService.instant("Dialog.SettingsComponent.msg_errorWhileSavingEmail");
    })
  }

  public requestEmailChange() {
    this.emailLoading = true;
    this.emailError = '';

    this.userService.requestEmailChange(
      this.emailForm.controls['email'].value,
      this.username
    ).then(() => {
      this.emailError = '';
      this.emailLoading = false;

      this.showForm(this.emailForm);
      this.exitFormEvent.emit(true);
    }).catch((err: HttpErrorResponse) => {
      this.emailLoading = false;
      if (err) {
        this.emailError = this.translateService.instant("EmailChangeMessages." + err.error);
      }
    })
  }

  public showForm(form: FormGroup) {
    if (form.controls['editing']) {
      if (form.controls['editing'].value) {
        form.controls['editing'].patchValue(false);

        Object.keys(form.controls).forEach((fieldName: string) => {
          form.controls[fieldName].patchValue(this.defaultFormValues[fieldName] || '');
        })
      } else {
        form.controls['editing'].patchValue(true);
      }
    }
  }

}
